module.exports = __webpack_public_path__ + "static/media/iconmubon.5e1df44e.png";